import featureOnboardingSlice from './featureOnboardingSlice'

export { FEATURE_TYPES, selectFeatures, updateOnboarding } from './featureOnboardingSlice'
export default featureOnboardingSlice
